import { ArrowRightIcon, XIcon } from 'lucide-react'

import { CaseProcessingTimeDescription } from '@/pages/ui/case-processing-time/case-processing-time-description/case-processing-time-description'
import { CaseProcessingTimeStatusText } from '@/pages/ui/case-processing-time/case-processing-time-status-text/case-processing-time-status-text'

import { Button } from '@/components/button/button'
import { Card, CardContent } from '@/components/card/card'

import { cn } from '@/lib/utils'

import { CaseProcessingTimeErrorBoundary } from '../case-processing-time-error-boundary'
import { MarkPremiumCase } from '../mark-premium-case'
import { SubmitCaseInquiry } from '../submit-case-inquiry'
import { ProcessingTimeDataDeleteConfirmDialog } from './processing-time-data-delete-confirm-dialog'
import { useCaseProcessingTimeInfo } from './use-case-processing-time-info'

export const CaseProcessingTimeInfo = () => {
  const {
    caseId,
    dataCaseExtraInfo,
    statusIcon,
    statusText,
    estimatedTime,
    estimatedTimeUnit,
    hasProcessingTimeData,
    showsSubmitCaseInquiry,
    isDeletingProcessingTimeData,
    isOpenProcessingTimeDataDeleteConfirmDialog,
    openUpdateCaseInfoDialog,
    openProcessingTimeTrendDialog,
    openProcessingTimeDataDeleteConfirmDialog,
    closeProcessingTimeDataDeleteConfirmDialog,
    handleGetProcessingTimeButton,
    handleClickDeleteConfirmButton,
  } = useCaseProcessingTimeInfo()

  if (!dataCaseExtraInfo?.caseInquiry && hasProcessingTimeData) {
    return <CaseProcessingTimeErrorBoundary />
  }

  return (
    <>
      {!hasProcessingTimeData && (
        <Button variant="outline" className={cn('h-[56px] w-full', 'py-4')} onClick={handleGetProcessingTimeButton}>
          <p className={cn('mr-auto')}>Set Processing Time Alert</p>
          <ArrowRightIcon size={24} />
        </Button>
      )}
      {hasProcessingTimeData && (
        <Card>
          <CardContent className={cn('px-4')}>
            {/* Status */}
            <div className={cn('flex items-center justify-between', 'pb-3.5 pt-6')}>
              <CaseProcessingTimeStatusText statusIconType={statusIcon} statusText={statusText} />
              <Button type="button" variant="ghost" size="icon" onClick={openProcessingTimeDataDeleteConfirmDialog}>
                <XIcon size={16} />
              </Button>
            </div>

            {/* Description */}
            <CaseProcessingTimeDescription estimatedTime={estimatedTime} unit={estimatedTimeUnit} />

            {/* Case Inquiry */}
            {showsSubmitCaseInquiry && caseId && (
              <SubmitCaseInquiry className="mt-3" caseId={caseId} submitted={dataCaseExtraInfo?.inquirySubmitted} />
            )}

            {caseId && <MarkPremiumCase caseId={caseId} markedPremium={dataCaseExtraInfo?.isPremium} />}

            {/* Button group */}
            <div className={cn('flex flex-col space-y-3', 'w-full', 'mt-3')}>
              <Button
                className={cn('text-xs font-medium')}
                variant="outline"
                size="sm"
                onClick={() => openUpdateCaseInfoDialog()}
              >
                Update Case Info
              </Button>
              <Button
                className={cn('text-xs font-medium')}
                variant="outline"
                size="sm"
                onClick={() => openProcessingTimeTrendDialog()}
              >
                Processing Times Trends
              </Button>
            </div>
          </CardContent>
        </Card>
      )}

      <ProcessingTimeDataDeleteConfirmDialog
        isOpen={isOpenProcessingTimeDataDeleteConfirmDialog}
        isDeleting={isDeletingProcessingTimeData}
        close={closeProcessingTimeDataDeleteConfirmDialog}
        onClickConfirmButton={handleClickDeleteConfirmButton}
      />
    </>
  )
}
